"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonLineHeight = exports.getButtonFontWeight = exports.getButtonFontSize = void 0;
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _mapButtonAppearance = require("./mapButtonAppearance");
const fontWeightTheme = (0, _sdsThemeInternal.themed)({
  primary: 700,
  secondary: 600,
  destructive: 700,
  "secondary-destructive": 600,
  share: 700,
  borderless: 600,
  link: {
    "lodestar-light": 400,
    "ursa-light": 500
  },
  "primary-filled": 500,
  "primary-empty": 500,
  "secondary-filled": 500,
  "secondary-outlined": 500,
  "secondary-empty": 500,
  "canvas-filled": 500,
  "canvas-empty": 500,
  "destructive-filled": 500,
  "destructive-empty": 500
});
const getButtonFontWeight = _ref => {
  let {
    appearance,
    themeMode
  } = _ref;
  return fontWeightTheme[(0, _mapButtonAppearance.mapButtonAppearance)(appearance, themeMode)](themeMode);
};
exports.getButtonFontWeight = getButtonFontWeight;
const fontSizeTheme = (0, _sdsThemeInternal.themed)({
  large: {
    "lodestar-light": "14px",
    "ursa-light": "14px"
  },
  medium: {
    "lodestar-light": "13px",
    "ursa-light": "14px"
  },
  small: {
    "lodestar-light": "13px",
    "ursa-light": "14px"
  },
  xsmall: {
    "lodestar-light": "13px",
    "ursa-light": "14px"
  }
});
const lineHeightTheme = (0, _sdsThemeInternal.themed)({
  "lodestar-light": "18px",
  "ursa-light": "16px"
});
const getButtonFontSize = _ref2 => {
  let {
    size,
    themeMode
  } = _ref2;
  return fontSizeTheme[size](themeMode);
};
exports.getButtonFontSize = getButtonFontSize;
const getButtonLineHeight = _ref3 => {
  let {
    themeMode
  } = _ref3;
  return lineHeightTheme(themeMode);
};
exports.getButtonLineHeight = getButtonLineHeight;
//# sourceMappingURL=getButtonFontStyles.js.map